// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Menu_wrapper__6c410","cartItemContainer":"Menu_cartItemContainer__1455a","noArticlesHint":"Menu_noArticlesHint__747ba","cartFooter":"Menu_cartFooter__ce04e"};